import styled from 'styled-components/macro';
import { ChevronButtonSC } from './components/chevron-button/chevron-button.styled';
import { InputSC } from '@components/input/input.styled';
import PasswordInputSC from '@components/password-input/password-input.styled';
import { Typography } from '@components/ui';

export const InfoWrapperSC = styled.div`
  grid-area: content;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: 0.4fr 0.7fr 20px 1.1fr 50px;
  grid-template-areas:
    '. .'
    '. header'
    '. .'
    '. text'
    'btn btn';

  @media (min-width: 900px) {
    grid-area: left-content;
    grid-template-columns: 1fr minmax(300px, 460px) 3fr;
    grid-template-rows: 1.5fr 20px auto 40px 64px 1fr;
    grid-template-areas:
      '. header .'
      '. . .'
      '. text .'
      '. . .'
      '. btn .'
      '. . .';

    ${ChevronButtonSC} {
      width: 250px;
      height: 64px;

      button {
        height: 100%;
        border-radius: 24px;
      }
    }

    .hilbi-logo {
      display: initial;
    }
  }
`;

export const AuthTitleSC = styled(Typography).attrs((p) => ({ ...p, display: 'h4' }))`
  margin-bottom: 24px;
`;

export const AuthInputSC = styled(InputSC)`
  margin-bottom: 0;
  .input-wrapper {
    label {
      line-height: 24px;
      color: #333d6c;
    }
  }

  .input-wrapper {
    & > div,
    & > input {
      background-color: ${({ error }) => (error ? '#ffcdd7' : 'rgba(202, 204, 216, 0.3)')};
    }
  }
`;

export const AuthPasswordInputSC = styled(PasswordInputSC)`
  .input-wrapper {
    input,
    .label {
      background-color: ${({ error }) => (error ? '#ffcdd7' : 'rgba(202, 204, 216, 0.3)')};
    }
  }
`;
